import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
//import firebase from 'firebase'
const fb = require('./firebaseConfig.js')
import "@/assets/flags/flags.css" // Manual Dropdwon Country flag
import VueTelInput from 'vue-tel-input'
Vue.use(VueTelInput)

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {}); // config is optional. more below
import "vue-wysiwyg/dist/vueWysiwyg.css";

import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
Vue.use(Vuetify, {
  iconfont: 'mdi'
})

window.axios = require('axios');

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

import { VueEditor } from "vue2-editor";
Vue.component('VueEditor', VueEditor)

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css' // only if your build system can import css, otherwise import it wherever you would import your css.
Vue.use(VuePlyr)

import VueStripeCheckout from 'vue-stripe-checkout';
//Vue.use(VueStripeCheckout, 'pk_0H2OyY9p8BDC7ey3wtx1Z6TAeeaMl'); //gopy
//Vue.use(VueStripeCheckout, 'pk_test_5ZP3hz11QvkzGzjYUXNDVKkp'); //pat dev
Vue.use(VueStripeCheckout, 'pk_live_DxH4fITgOGr3IgKSg8fp3OQ1'); // pat live



/* Firebase Config */
/*firebase.initializeApp({
  apiKey: process.env.apiKey,
  authDomain: process.env.authDomain,
  databaseURL: process.env.databaseURL,
  projectId: process.env.projectId
})*/

//Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBsAJdk_Cn0ZRs3Cz8RCGQiEIuuZj6um6A",
    libraries: "places" // necessary for places input
  }
});

import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)

import VueClipboards from 'vue-clipboards';
Vue.use(VueClipboards);


import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce)


import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
Vue.component('VSwatches', VSwatches)

import GAuth from 'vue-google-oauth2'
// const gauthOption = { //gopystar
//   //clientId: '907439240339-ej22v14kcl67q6vmposuipls00di6r9s.apps.googleusercontent.com',
//   clientId: '874841771172-d7drdg924fh9hr3bqe3n78e7davaiip4.apps.googleusercontent.com',
//   //scope: 'profile email https://www.googleapis.com/auth/photoslibrary.readonly https://www.googleapis.com/auth/photoslibrary.sharing',
//   scope: 'openid profile email https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/contacts',
//   //prompt: 'select_account',
//   prompt:'consent',
//   expiresIn:86400
// }

/* 27 Apr 2020 */
const gauthOption = { //abit-mobile
  clientId: '874841771172-btnu8l3f7kog48j7t3fh4ijvpqjhsnud.apps.googleusercontent.com',
  scope: 'openid profile email https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/contacts https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.compose https://www.googleapis.com/auth/tasks.readonly https://www.googleapis.com/auth/tasks',
  //prompt: 'select_account',
  prompt:'consent',
  fetch_basic_profile:true,
  expiresIn:86400
}
/* 27 Apr 2020 */

/*const gauthOption = {
  clientId: '874841771172-d7drdg924fh9hr3bqe3n78e7davaiip4.apps.googleusercontent.com',
  //scope: 'profile email https://www.googleapis.com/auth/photoslibrary.readonly https://www.googleapis.com/auth/photoslibrary.sharing',
  scope: 'profile email https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/calendar.readonly',
  prompt: 'select_account',
  expiresIn:86400
}
*/

Vue.use(GAuth, gauthOption);


import JsonViewer from 'vue-json-viewer'
import 'vue-json-viewer/style.css'

Vue.use(JsonViewer)

/*import VueAuthenticate from 'vue-authenticate'
Vue.use(VueAuthenticate, {
  baseUrl: 'http://localhost:5000', // Your API domain
  providers: {
    github: {
      clientId: '533edf9c9169722dcfba',
      redirectUri: 'http://localhost:5000/auth/github' // Your client app URL
    }
  }
})*/

router.afterEach((to, from) => {
  //NProgress.done()  
   store.commit('setPageload', false)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const unsubscribe = fb.auth.onAuthStateChanged((firebaseUser) => {
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    created () {
      if (firebaseUser) {
        store.dispatch('autoSignIn', firebaseUser)
      }
    }
  })
  unsubscribe()
})



// WEBPACK FOOTER //
// ./src/main.js